import type { MonospaceServiceAccount, MonospaceSystemProjectMember } from '#layers/data-model';
import { RStoreSchema } from '#imports';
import { Project } from './project';

export const ServiceAccount = RStoreSchema.withItemType<MonospaceServiceAccount>().defineCollection({
	name: 'MonospaceServiceAccount',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'fullName',
		],
		endpoint: 'system/service-accounts',
	},
});

// Junction table between User/ServiceAccount and Project
export const SystemProjectMember = RStoreSchema.withItemType<MonospaceSystemProjectMember>().defineCollection({
	name: 'MonospaceProjectMember',
	scopeId: 'monospace-default',
	getKey: (item) => `${item.userId}__${item.projectId}`,
	meta: {
		defaultFields: ['userId', 'projectId'],
	},
});

export const ServiceAccountRelations = RStoreSchema.defineRelations(ServiceAccount, ({ collection }) => ({
	projects: {
		to: collection(SystemProjectMember, {
			on: {
				'MonospaceProjectMember.userId': 'MonospaceServiceAccount.id',
			},
		}),
		many: true,
	},
}));

export const SystemProjectMemberRelations = RStoreSchema.defineRelations(SystemProjectMember, ({ collection }) => ({
	project: {
		to: collection(Project, {
			on: {
				'MonospaceProject.id': 'MonospaceProjectMember.projectId',
			},
		}),
	},
}));
